import { FunctionComponent, PropsWithChildren, ReactNode } from "react";
import { StyledButton, TSchemaButton } from "./styles";

interface ButtonProps {
  action?: () => void;
  icon?: ReactNode;
  schemaButton: TSchemaButton;
  disabled?: boolean;
  position?: string;
  top?: number;
  left?: number;
  right?: number;
  className?: string;
  id?: string;
  type?: "button" | "submit" | "reset";
  style?: any;
}

const Button: FunctionComponent<PropsWithChildren<ButtonProps>> = ({
  children,
  action,
  icon,
  schemaButton,
  disabled,
  position,
  top,
  left,
  right,
  className,
  id,
  type = "button",
  style,
}) => {
  return (
    <StyledButton
      onClick={action}
      schemaButton={schemaButton}
      disabled={disabled}
      position={position}
      top={top}
      left={left}
      right={right}
      className={className}
      id={id}
      type={type}
      style={style}
    >
      {icon && icon}
      {children}
    </StyledButton>
  );
};

export default Button;
